import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import './Passport.css';

function Passport() {
  return (
    <div className="passports">
      <Helmet>
        <title>Get Your Portugal Pavilion Tickets | Carassauga 2025 Passports</title>
        <meta name="description" content="Purchase your Portugal Pavilion tickets for Carassauga 2025. Get your passports to experience authentic Portuguese culture, food, and entertainment." />
        <meta name="keywords" content="Portugal Pavilion tickets, Carassauga 2025 passports, Portuguese festival tickets, Mississauga cultural event tickets" />
        <link rel="canonical" href="https://carassauga2025.web.app/passports" />
      </Helmet>
      <Navbar />
      <h1 style={{color: 'white', zIndex: 9999}}>TEST: Passport Page Loaded</h1>


      <video autoPlay muted loop playsInline className="bg-video">
        <source src="/videos/bg-dove.mp4" type="video/mp4" />
      </video>

      <motion.div
        className="content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <img className="passports-title" src="/images/passport/passports-title.svg" alt="PASSPORTS" />
        <img className="passports-icon" src="/images/passport/group-icon.svg" alt="Icon" />
        <img className="passports-year" src="/images/passport/2025.svg" alt="2025" />

        <div className="buy-section">
          <a
            className="buy-button"
            href="https://www.carassauga.com/visitorinformation/admission/"
            target="_blank"
            rel="noopener noreferrer"
          >
            BUY
          </a>
          <div className="footer-text">
            <div className="footer-title">AT CARASSAUGA WEBSITE</div>
            <div className="footer-handle">www.carassauga.ca</div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default Passport;
